import { Box, Container, Typography, Stack, Divider } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import PageHero from '../components/common/PageHero';
import AnimatedSection from '../components/common/AnimatedSection';
import { useLegal } from '../hooks/usePublicApi';
import { impressum as staticImpressum } from '../data/legal';

export default function Impressum() {
  const { legal: apiData } = useLegal('impressum');
  const impressum = apiData || staticImpressum;

  return (
    <>
      <Helmet>
        <title>Impressum — Süd Ausbau GmbH</title>
      </Helmet>

      <PageHero title="Impressum" />

      <Box sx={{ py: { xs: 6, md: 10 } }}>
        <Container maxWidth="md">
          <AnimatedSection>
            <Stack spacing={4}>
              <Box>
                <Typography variant="h4" sx={{ mb: 2 }}>Angaben gemäß § 5 TMG</Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>{impressum.company}</Typography>
                <Typography variant="body1">{impressum.address?.street}</Typography>
                <Typography variant="body1">{impressum.address?.zip} {impressum.address?.city}</Typography>
              </Box>

              <Divider />

              <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>Kontakt</Typography>
                <Typography variant="body1">Telefon: {impressum.contact?.phone}</Typography>
                <Typography variant="body1">Fax: {impressum.contact?.fax}</Typography>
                <Typography variant="body1">E-Mail: {impressum.contact?.email}</Typography>
                <Typography variant="body1">Web: {impressum.contact?.website}</Typography>
              </Box>

              <Divider />

              <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>Vertreten durch</Typography>
                <Typography variant="body1">Geschäftsführer: {impressum.legal?.ceo}</Typography>
              </Box>

              <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>Registereintrag</Typography>
                <Typography variant="body1">Registergericht: {impressum.legal?.court}</Typography>
                <Typography variant="body1">Registernummer: {impressum.legal?.hrb}</Typography>
                <Typography variant="body1">Umsatzsteuer-ID: {impressum.legal?.vatId}</Typography>
              </Box>

              <Divider />

              <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>Haftung für Inhalte</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                  {impressum.disclaimer}
                </Typography>
              </Box>

              <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>Haftung für Links</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                  {impressum.linkDisclaimer}
                </Typography>
              </Box>

              <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>Urheberrecht</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                  {impressum.copyright}
                </Typography>
              </Box>
            </Stack>
          </AnimatedSection>
        </Container>
      </Box>
    </>
  );
}
